import React from 'react';
import './Home.js.css';
import Container from '../components/Container';
import '../styles/generics.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageComponent from '../components/PageComponent';
import Labels from '../Labels';
import Connection from '../config/Connection';
import { Modal, Button, InputGroup, Form, Dropdown, DropdownButton, FormControl } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Parsers from '../Tools/Parsers';
import GenericHelper from '../Tools/GenericHelper';
import AdminStateGroupPage from './AdminStateGroupPage';
import MaskedInput from '../components/MaskedInput';
import ErrorComponent from '../components/ErrorComponent';

export default class AdminStateGroupDetailPage extends PageComponent {

  static PageInfo = {
    parent: AdminStateGroupPage,
    path: "/Admin/StateGroup/:id",
    name: "menu.stategroupdetail",
    permission: { "CONFIGURATION_REGIONAL_ACCESSING": true },
    access: { 1: true },
    icon: "map-marked-alt",
    hidden: true
  }

  constructor(props) {
    super(props);
    this.data = props.match.params;
    this.state.data = null;
    this.state.brands = null;
    this.state.modalError = null;
    this.state.group = [];
    this.state.filteredGroup = [];
    this.state.selectionType = "name";
    this.state.selectedPerson = null;
    this.state.loading = true;
    this.state.modalLoading = false;
    this.state.isModalVisible = false;
    this.state.brandsLoading = true;
    this.state.modalInitializing = false;
  }

  componentDidMount() {
    Connection.Secure(Connection.service + 'StateGroup/Detail/' + this.data.id)
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            setTimeout(() => this.setState({ data: data, loading: false }));
          });
        else this.setState({ response: true, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });
  }

  openModal(target) {
    if (target !== "EMPLOYEE_FRANCHISEE")
      Connection.Secure(Connection.service + 'User/AD/List/' + target.replace("EMPLOYEE", "INC"))
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              setTimeout(() => this.setState({ group: data, filteredGroup: data, modalInitializing: false }));
            });
          this.setState({ modalInitializing: false });
        })
        .catch((error) => {
          this.setState({ modalInitializing: false });
        });
    else
      Connection.Secure(Connection.service + 'State/List/')
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              setTimeout(() => this.setState({ states: data }, this.setState({ modalInitializing: false })));
            });
          this.setState({ modalError: response, modalInitializing: false });
        })
        .catch((error) => {
          this.setState({ modalError: error, modalInitializing: false });
        });
    this.setState({
      modalInitializing: true, isModalVisible: true, group: [], type: target, selectedBrand: null,
      modalLoading: false,
      modalError: null,
      selectedPerson: null
    });
  }


  searchClients() {
    this.setState({ costumerLoading: true, clientList: [] });
    Connection.Secure(Connection.service + "CustomerFK/List/ZFR",
      {
        "method": "POST",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({ city: this.state.city, name1: this.state.selectionType == "name" ? this.state.filter : null, cnpjCode: this.state.selectionType != "name" ? this.state.filter : null, region: this.state.region })
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            this.setState({ costumerLoading: false, clientList: data });
          });
        else this.setState({ modalError: response, costumerLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, costumerLoading: false });
      });
  }
  searchClients() {
    this.setState({ costumerLoading: true, clientList: [] });
    Connection.Secure(Connection.service + "CustomerFK/List/ZFR",
      {
        "method": "POST",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({
          city: this.state.city, name1: this.state.selectionType == "name" ? this.state.filter : null, customerCode: this.state.selectionType == "customercode" ? this.state.filter : null,
          cnpjCode: this.state.selectionType == "docnumb" ? this.state.filter : null, region: this.state.region
        })

      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            this.setState({ costumerLoading: false, clientList: data });
          });
        else this.setState({ costumerLoading: false });
      })
      .catch((error) => {
        this.setState({ costumerLoading: false });
      });
  }

  setBrand(target) {
    if (this.state.type === "EMPLOYEE_FRANCHISEE") {
      Connection.Secure(Connection.service + 'Franchise/List/' + this.state.data.brand.keyConstant,
        {
          "method": "POST",
          "headers": {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              setTimeout(() => this.setState({ group: data, filteredGroup: data, modalInitializing: false }));
            });
          else this.setState({ modalError: response, modalInitializing: false });
        })
        .catch((error) => {
          this.setState({ modalError: error, modalInitializing: false });
        });
      this.setState({ selectedBrand: target, modalInitializing: true, selectedPerson: null });
    }
    else this.setState({ selectedBrand: target });
  }
  changeDropdown(target) {
    this.setState({ selectionType: target, filter: "" });
  }

  addUser(target) {
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service + (
      this.state.type == "EMPLOYEE_AREA_LEADER" ?
        "AreaLeader/Vinculate/" + this.data.id + "/" + this.state.selectedPerson.samAccountName
        :
        this.state.type == "EMPLOYEE_FRANCHISE_MANAGER" ?
          "FranchiseManager/Vinculate/" + this.data.id + "/" + this.state.selectedPerson.samAccountName
          :
          this.state.type == "EMPLOYEE_REGION_BRAND_MANAGER" ?
            "MarketDevManager/Vinculate/" + this.data.id + "/" + this.state.selectedPerson.samAccountName
            :
            this.state.type == "EMPLOYEE_FRANCHISEE" ?
              "Franchise/Vinculate/" + this.data.id + "/" + target.customerCode
              : ""
    ),
      {
        "method": "POST",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            try {
              if (this.state.type == "EMPLOYEE_AREA_LEADER")
                this.state.data.areaLeader.push(data);
              else if (this.state.type == "EMPLOYEE_FRANCHISE_MANAGER")
                this.state.data.franchiseManager.push(data);
              else if (this.state.type == "EMPLOYEE_REGION_BRAND_MANAGER")
                this.state.data.marketDevManager.push(data);
              else if (this.state.type == "EMPLOYEE_FRANCHISEE")
                this.state.data.franchiseeDetail.push(data);
            } catch (e) { }
            this.setState({ isModalVisible: false, data: this.state.data, modalLoading: false });
          });
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  deleteItem(ev, target, item) {
    this.setState({ isModalVisible: true, modalLoading: true });
    Connection.Secure(Connection.service + (
      target == "EMPLOYEE_AREA_LEADER" ?
        "AreaLeader/Remove/" + this.data.id + "/" + item.mainPerson.keyRegister
        :
        target == "EMPLOYEE_FRANCHISE_MANAGER" ?
          "FranchiseManager/Remove/" + this.data.id + "/" + item.mainPerson.keyRegister
          :
          target == "EMPLOYEE_REGION_BRAND_MANAGER" ?
            "MarketDevManager/Remove/" + this.data.id + "/" + item.mainPerson.keyRegister
            :
            target == "EMPLOYEE_FRANCHISEE" ?
              "Franchise/Desvinculate/" + this.data.id + "/" + item.mainCompany.keyRegister
              : ""
    ),
      {
        "method": "DELETE",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.ok && response.status == 200) {
          try {
            if (target == "EMPLOYEE_AREA_LEADER")
              this.state.data.areaLeader.splice(this.state.data.areaLeader.indexOf(item), 1);
            else if (target == "EMPLOYEE_FRANCHISE_MANAGER")
              this.state.data.franchiseManager.splice(this.state.data.franchiseManager.indexOf(item), 1);
            else if (target == "EMPLOYEE_REGION_BRAND_MANAGER")
              this.state.data.marketDevManager.splice(this.state.data.marketDevManager.indexOf(item), 1);
            else if (target == "EMPLOYEE_FRANCHISEE")
              this.state.data.franchiseeDetail.splice(this.state.data.franchiseeDetail.indexOf(item), 1);
          } catch (e) { }
          this.setState({ modalLoading: false, isModalVisible: false, data: this.state.data });
        } else
          this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });

    if (ev.stopPropagation) ev.stopPropagation();
    else ev.cancelBubble = true;
    (ev.preventDefault) ? ev.preventDefault() : ev.returnValue = false;
    // return false;
  }

  renderUserInfo(item, icon, op) {
    var l = window.location.pathname.replace(/\/$/ig, "") + "/User/" + item.mainPerson.keyRegister;
    return <Link to={l} className="generics_listing_item" >
      <FontAwesomeIcon icon={icon} className="generics_listing_item_icon" />
      <div className="generics_listing_content" >
        <div className="generics_listing_item_title" >{Parsers.parseUpperCase(GenericHelper.parseInformation(item.mainPerson.personValue, 1, "valueType"))} </div>
        <div className="generics_listing_item_description" >{GenericHelper.parseInformation(item.mainPerson.personValue, 13, "valueType", null)} {GenericHelper.parseInformation(item.mainPerson.personValue, 18, "valueType", null, " - ")}</div>
        <div className="generics_listing_item_description" >{Parsers.parseLowerCase(GenericHelper.parseInformation(item.mainPerson.personValue, 3, "valueType"))}<span>{Labels.GetLabel("generic.shortreg")}.:{GenericHelper.parseInformation(item.mainPerson.personValue, 16, "valueType", "0000000")}</span></div>
      </div>
      <div className="generics_listing_item_action" onClick={(e) => this.deleteItem(e, op, item)}><FontAwesomeIcon icon="times" /></div>
    </Link>
  }

  renderFranchiseeInfo(item, icon, op) {
    var l = window.location.pathname.replace(/\/$/ig, "") + "/Company/" + item.mainCompany.keyRegister;
    return <Link to={l} className="generics_listing_item" >
      <FontAwesomeIcon icon={icon} className="generics_listing_item_icon" />
      <div className="generics_listing_content" >
        <div className="generics_listing_item_title" >{item.detail.name1}</div>
        <div className="generics_listing_item_description" >{Parsers.parseCPNJ(item.detail.cnpjCode)}</div>
        {item.mainCompany.personPermissionGroup.length == 0 ? <div className="generics_listing_item_description" style={{ textAlign: "right" }} >N/A</div> :
          item.mainCompany.personPermissionGroup.map(item =>
            <div className="generics_listing_item_description" style={{ textAlign: "right" }} ><FontAwesomeIcon icon={"user"} style={{ opacity: 0.5 }} /> {Parsers.parseUpperCase(GenericHelper.parseInformation(item.mainPerson.personValue, 1, "valueType"))}  </div>)}
      </div>

      <div className="generics_listing_item_action" onClick={(e) => this.deleteItem(e, op, item)}><FontAwesomeIcon icon="times" /></div>
    </Link>
  }

  render() {
    return (
      <Container context={this.constructor}>

        <div className="generics_panels" style={{ display: "block" }}>
          {
            this.state.error != null ? <ErrorComponent error={this.state.error} /> :
              this.state.loading ? <div>{Labels.GetLabel("generic.loading")}</div> :
                <div>
                  <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span>{this.state.data.label} {Labels.GetLabel(this.constructor.PageInfo.name)}</span></div>
                  <div>
                    <div>
                      <div className="generic_section_header">{Labels.GetLabel('adminstategroupdetail.EMPLOYEE_AREA_LEADER')}
                        <div className="generic_section_header_action" onClick={() => this.openModal("EMPLOYEE_AREA_LEADER")}><FontAwesomeIcon icon="plus" /></div></div>
                      {
                        this.state.data &&
                          this.state.data.areaLeader.length == 0 ? <div className="generic_empty">{Labels.GetLabel('adminstategroupdetail.empty')}</div>
                          :
                          this.state.data.areaLeader.map((item) => this.renderUserInfo(item, "chess-king", "EMPLOYEE_AREA_LEADER"))
                      }
                      <br />
                      <div className="generic_section_header">{Labels.GetLabel('adminstategroupdetail.EMPLOYEE_REGION_BRAND_MANAGER')}
                        <div className="generic_section_header_action" onClick={() => this.openModal("EMPLOYEE_REGION_BRAND_MANAGER")}><FontAwesomeIcon icon="plus" /></div></div>
                      {
                        this.state.data &&
                          this.state.data.marketDevManager.length == 0 ? <div className="generic_empty">{Labels.GetLabel('adminstategroupdetail.empty')}</div>
                          :
                          this.state.data.marketDevManager.map((item) => this.renderUserInfo(item, "chess-king", "EMPLOYEE_REGION_BRAND_MANAGER"))
                      }
                      <br />
                      <div className="generic_section_header">{Labels.GetLabel('adminstategroupdetail.EMPLOYEE_FRANCHISE_MANAGER')}
                        <div className="generic_section_header_action" onClick={() => this.openModal("EMPLOYEE_FRANCHISE_MANAGER")}><FontAwesomeIcon icon="plus" /></div>
                      </div>
                      {
                        this.state.data &&
                          this.state.data.franchiseManager.length == 0 ? <div className="generic_empty">{Labels.GetLabel('adminstategroupdetail.empty')}</div>
                          : this.state.data.franchiseManager.map((item) => this.renderUserInfo(item, "chess-rook", "EMPLOYEE_FRANCHISE_MANAGER"))}
                      <br />
                      <div className="generic_section_header">{Labels.GetLabel('adminstategroupdetail.EMPLOYEE_FRANCHISEE_listing')}
                        <div className="generic_section_header_action" onClick={() => this.openModal("EMPLOYEE_FRANCHISEE")}><FontAwesomeIcon icon="plus" /></div></div>
                      {
                        this.state.data &&
                          this.state.data.franchiseeDetail.length == 0 ? <div className="generic_empty">{Labels.GetLabel('adminstategroupdetail.empty')}</div>
                          : this.state.data.franchiseeDetail.map((item) => this.renderFranchiseeInfo(item, "chess-pawn", "EMPLOYEE_FRANCHISEE"))}
                    </div>
                  </div>
                </div>
          }

          {/* <div className="generics_floatinbtn" onClick={() => this.setState({ isModalVisible: true })}>
            <FontAwesomeIcon className="generics_floatinbtn_icon" icon="plus" />
          </div> */}

          <Modal
            className={this.state.modalLoading == true ? "modal-loading" : ""}
            onHide={() => { }} show={this.state.isModalVisible}
          // onHide={handleClose}
          >
            <div>
              {this.state.type == "EMPLOYEE_FRANCHISEE" ?
                <div>
                  <Modal.Header>
                    <Modal.Title>{Labels.GetLabel("adminstategroupdetail.EMPLOYEE_FRANCHISEE")}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <InputGroup className="mb-3">
                      <DropdownButton
                        as={InputGroup.Prepend}
                        variant="outline-secondary"
                        title={Labels.GetLabel("generic." + this.state.selectionType)}
                      >
                        <Dropdown.Item href="#" onClick={(t) => this.changeDropdown("name")}>{Labels.GetLabel("generic.name")}</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={(t) => this.changeDropdown("docnumb")}>{Labels.GetLabel("generic.docnumb")}</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={(t) => this.changeDropdown("customercode")}>{Labels.GetLabel("generic.customercode")}</Dropdown.Item>
                      </DropdownButton>
                      <FormControl aria-describedby="basic-addon1" value={this.state.filter} onChange={(v) => this.setState({ filter: v.currentTarget.value })} />
                    </InputGroup>
                    <div style={{ display: "flex" }}>
                      <div style={{ width: "30%", marginRight: 10 }}>
                        <MaskedInput type="select" onValid={(value) => { this.setState({ region: Array.isArray(value) ? value[0] : null }) }}
                          onInvalid={(value) => this.setState({ region: null })} name="label,description" data={() => { return this.state.states }} placeholder={Labels.GetLabel("generic.state")} />
                      </div>
                      <div style={{ flex: 1 }}>
                        <MaskedInput type="text" onValid={(value) => this.setState({ city: value == null ? null : value.normalize("NFD").replace(/[\u0300-\u036f]/g, "") })}
                          onInvalid={(value) => this.setState({ city: null })} placeholder={Labels.GetLabel("generic.city")} />
                      </div>
                    </div>
                    <Button variant="success" block disabled={this.state.modalInitializing} onClick={() => this.searchClients()}>
                      {Labels.GetLabel("clients.pesquisar")}
                    </Button>
                    <br />
                    <div className="generics_panels_header"><FontAwesomeIcon icon="list" /> <span>{Labels.GetLabel("clients.results")} ({Array.isArray(this.state.clientList) && this.state.clientList.length > 0 ? this.state.clientList.length : 0})</span></div>
                    {
                      this.state.costumerLoading ? <div>{Labels.GetLabel("generic.loading")}</div> :
                        Array.isArray(this.state.clientList) && this.state.clientList.length > 0 ?
                          this.state.clientList.map((item) => {
                            var v = true;
                            for (let i = 0; i < this.state.data.franchiseeDetail.length; i++)
                              if (this.state.data.franchiseeDetail[i].mainCompany.keyRegister == item.customerCode) {
                                v = false;
                                break;
                              }

                            return v ? <Link onClick={() => this.addUser(item)} className="generics_listing_item"  >
                              <FontAwesomeIcon icon="building" className="generics_listing_item_icon" />
                              <div className="generics_listing_content" >
                                <div>#{item.customerCode}</div>
                                <div className="generics_listing_item_title" >{item.name1 + (item.name2 == null ? "" : item.name2)
                                  + (item.name3 == null ? "" : item.name3)
                                  + (item.name4 == null ? "" : item.name4)}</div>
                                <div className="generics_listing_item_description" >{Parsers.parseCPNJ(item.cnpjCode)}</div>
                              </div>
                            </Link> : <div className="generics_listing_item" style={{ backgroundColor: "#f1ffe7", opacity: 0.5 }}  >
                                <FontAwesomeIcon icon="building" className="generics_listing_item_icon" />
                                <div className="generics_listing_content" >
                                  <div>#{item.customerCode}</div>
                                  <div className="generics_listing_item_title" >{item.name1 + (item.name2 == null ? "" : item.name2)
                                    + (item.name3 == null ? "" : item.name3)
                                    + (item.name4 == null ? "" : item.name4)}</div>
                                  <div className="generics_listing_item_description" >{Parsers.parseCPNJ(item.cnpjCode)}</div>
                                </div>
                              </div>

                          })
                          : this.state.data == null ?
                            <div className="generic_empty">{Labels.GetLabel('generic.fillParameters')}</div>
                            :
                            <div className="generic_empty">{Labels.GetLabel('generic.noresult')}</div>
                    }
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                      {Labels.GetLabel("adminstategroup.closebtn")}
                    </Button>
                  </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                </div>
                :
                this.state.modalInitializing == false ?
                  <div>
                    <Modal.Header>
                      <Modal.Title>{Labels.GetLabel("adminstategroupdetail." + this.state.type)}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form.Group >
                        <Form.Label>{Labels.GetLabel("adminstategroupdetail.newlabel")}</Form.Label>

                        <Form.Control type="text" placeholder={Labels.GetLabel("generic.searchterm")} onChange={(text) => this.setState({
                          filteredGroup: this.state.group.filter((item) => {
                            var c = text.currentTarget.value.toLowerCase();
                            return this.state.selectedPerson == item || item.name.toLowerCase().indexOf(c) > -1;
                          })
                        })} />
                        {
                          this.state.modalInitializing ? <div className="generics_loader_infoblock">{Labels.GetLabel("generic.loading")}</div> :
                            this.state.group.length == 0 ? <div className="generics_loader_infoblock">{Labels.GetLabel("generic.noresult")}</div> :
                              <div className="generic_list">
                                {
                                  this.state.filteredGroup.map((item) =>
                                    <div className={this.state.selectedPerson == item ? "generic_list_item selected" : "generic_list_item"} onClick={() => this.setState({ selectedPerson: this.state.selectedPerson == item ? null : item })}>{
                                      this.state.type === "EMPLOYEE_FRANCHISEE" ? item.detail.name1 : item.name
                                    }</div>)
                                }
                              </div>
                        }
                      </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={() => this.setState({ isModalVisible: false })}>
                        {Labels.GetLabel("adminstategroup.closebtn")}
                      </Button>
                      <Button variant="primary" disabled={
                        this.state.selectedPerson == null
                      } onClick={() => this.addUser()}>
                        {Labels.GetLabel("adminstategroup.savebtn")}
                      </Button>
                    </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                  </div>
                  : <div>
                    {Labels.GetLabel("adminstategroup.saving")}
                  </div>
              }
            </div>
          </Modal>
        </div>
      </Container >
    );
  }
}